import { Controller } from "@hotwired/stimulus";
import { useOutlets } from "hb/insights/use_outlets";

export default class extends Controller {
  connect() {
    useOutlets(this, { components: ["handsfree"] });
  }

  toggleShowHandsfree() {
    this.element.classList.toggle("show-handsfree");
  }

  valSel(evt) {
    if (!window.getSelection().isCollapsed) {
      return;
    }

    const ds = evt.target.dataset;
    let val = ds.value;
    let context = ds.context || "site";
    let prepend = [];

    this.outletComponent("handsfree").show("str", ds.path, val, {
      prepend,
      context,
      element: this.element,
      addToField: false,
    });
  }
}
